module.exports = __webpack_public_path__ + "static/creativity-inc-d4ddf8177db817a4fdd3309506ec4e79.jpg";